<template>
  <div>
    <commonTable
      ref="commonTable"
      :thead="thead"
      :tpropty="tpropty"
      :table-data="tableData"
      :total="total"
      :pagesize="pageSize"
      @transmitParams="getDatasourceList"
      @dialogDeleteSure="getDatasourceDelete"
      @handleCommand="handleCommand"
    />
    <updateSourceDialog
      ref="updateSourceDialog"
      :encoding-list="encodingList"
      :server-data="serverData"
      :is-alter="isAlter"
      @updateSource="updateSource"
    />
  </div>
</template>
<script>
import { toTopAnimation } from '@common/util.js'
import APIS from '@apis/dataCenter.js'
import commonTable from '@components/dataCenter/listTemplate'
import updateSourceDialog from './components/dataDialog'
export default {
  components: {
    commonTable,
    updateSourceDialog
  },
  props: {
    thead: {
      type: Array,
      default: () => [
        '数据源名称',
        '存储类型',
        '数据库类型',
        'IP',
        '是否可用',
        '最后更新时间'
      ]
    },
    module: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isSelectedSource() {
      return this.$store.state['dataCenter'].isSelectedSource
    },
    isBusinessDs() {
      return this.$route.path === '/etl/business/ds'
    },
    sourceId() {
      return parseInt(this.$route.query.id)
    }
  },
  data() {
    return {
      encodingList: [],
      serverData: [],
      tpropty: ['name', 'kind', 'type', 'ip', 'enabled', 'lastModified'],
      tableData: [],
      total: 0,
      pageSize: 10,
      isAlter: false
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
    this.getServerData()
    this.getEncoding()
  },
  mounted() {
    if (this.isSelectedSource && this.isBusinessDs) {
      this.$nextTick(() => {
        this.$refs.updateSourceDialog.$refs.dialog.cyDialogCommon = true
        this.isAlter = true
        this.getDatasourceList({ id: this.sourceId, module: 2 }, true)
      })
    }
  },
  methods: {
    // 获取存储类型列表树
    async getServerData() {
      let { status, data } = await APIS.getDatasourceTypes()
      if (status === 0 && data && data.length !== 0) {
        this.serverData = data
      } else {
        this.serverData = []
      }
    },
    // 获取编码类型
    async getEncoding() {
      let { status, data } = await APIS.getEncoding()
      if (status === 0 && data && data.length !== 0) {
        this.encodingList = data
      } else {
        this.encodingList = []
      }
    },
    // 数据源查询
    // isEdit：是否是业务库跳转过来查询单条数据
    async getDatasourceList(val, isEdit = false) {
      let { status, data } = await APIS.postDatasourceList({
        data: Object.assign({}, val, { module: this.module })
      })
      if (status === 0 && data && data.rows && data.rows.length !== 0) {
        if (isEdit) {
          this.$refs.updateSourceDialog.init(
            Object.assign(data.rows[0], {
              encodingId: data.rows[0].encodingId === 0 ? '' : data.rows[0].encodingId,
              driverId: data.rows[0].driverId === 0 ? '' : data.rows[0].driverId
            })
          )
          return false
        }
        this.total = data.total
        this.tableData = data.rows.map(item => {
          return {
            ...item,
            encodingId: item.encodingId === 0 ? '' : item.encodingId,
            driverId: item.driverId === 0 ? '' : item.driverId
          }
        })
        toTopAnimation()
      } else {
        if (isEdit) {
          this.isAlter = false
          this.$refs.updateSourceDialog.init()
          return false
        }
        this.total = 0
        this.tableData = []
      }
    },
    // 数据源新增、修改
    async updateSource({ params, isConfig, isAlter }) {
      if (!isAlter) {
        params = Object.assign(params, { module: this.module })
      }
      let _api = APIS.postDatasourceAdd
      if (isAlter) {
        _api = APIS.postDatasourceUpdate
      }
      let { status, message, data } = await _api({
        data: params,
        headers: { 'Content-Type': 'application/json' }
      })
      this.global_.handleMessageTips(
        message,
        status === 0 ? 'success' : 'error'
      )
      if (status === 0) {
        this.$refs.updateSourceDialog.$refs.dialog.closeDialog()
        if (!isConfig) {
          this.$refs.commonTable.resetList()
          return false
        }
        this.$store.commit('dataCenter/updateIsSelectedSource', true)
        this.$router.push(`/etl/business/lib?id=${data}`)
      }
    },
    // 数据源删除、启用、禁用
    async getDatasourceDelete({ ids, mode }) {
      let params = { ids: ids }
      let _apis = APIS.postDatasourceDelete
      if (mode !== 'delete') {
        _apis = APIS.postDatasourceIsEnable
        params = Object.assign({}, params, {
          toEnable: mode === 'enable' ? 1 : 0
        })
      }
      let { status, message } = await _apis({
        data: params
      })
      if (message !== '') {
        this.global_.handleMessageTips(
          message,
          status === 0 ? 'success' : 'error'
        )
      }
      if (status === 0) {
        this.$refs.commonTable.resetList()
        this.$refs.commonTable.$refs.deleteDialog.cyDialogCommon = false
      }
    },
    handleCommand(code) {
      if (code === 'etl_business_ds_lib') {
        let ids = this.$refs.commonTable.selectData
          .map(item => item.id)
          .join(',')
        this.$router.push({ path: '/etl/business/lib', query: { ids: ids } })
        return false
      }
      this.$refs.updateSourceDialog.$refs.dialog.cyDialogCommon = true
      this.isAlter = code === 'edit'
      this.$refs.updateSourceDialog.init(
        this.isAlter ? this.$refs.commonTable.selectData[0] : undefined
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.sort {
  float: right;
  line-height: 25px;
  text-align: right;
  color: #454647;
  font-size: 12px;
  cursor: pointer;
}
// 表格
/deep/ .el-table {
  .el-table__header-wrapper {
    border-radius: 5px 5px 0px 0px;
  }
  .el-table__body-wrapper {
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 5px 5px;
  }
  th.is-leaf {
    // 表头样式修改
    border-left: 1px solid #a7ccec;
    background: #3b91dd;
    color: #fff;
    font-weight: 400;
    border-bottom: 1px solid #e8e8e8;
  }
  tbody td {
    height: 60px;
    border-bottom: 1px solid #e8e8e8;
  }
  /*表格全选框去除空框*/
  .select-all .cell {
    .el-checkbox__input .el-checkbox__inner {
      background: #fff;
      position: relative;
      &::after {
        border-color: #fff;
        transform: rotate(45deg) scaleY(1);
      }
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background: #3273ff;
    }
  }
  .el-checkbox__input .el-checkbox__inner {
    outline: none;
    &:after {
      border-color: #fff;
      transform: rotate(45deg) scaleY(1);
    }
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #3273ff;
  }
  .el-icon-error {
    color: #999999;
  }
  .el-icon-success {
    color: #52a544;
  }
}
/deep/ .el-pagination {
  margin-top: 20px;
  .btn-next,
  .btn-prev,
  .el-pager li {
    background: #fff;
  }
}
</style>
